import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/redux-promise` if it exist... Remove this comment to see the full error message
import promise from 'redux-promise';
import {unauthorizedLogout} from '@pluto/unauthorized-logout';

import rootReducer from './rootStore';

export default function configureStore() {
    let middleware = [
        promise,
        unauthorizedLogout,
        thunk,
    ];
    
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'StoreEnhancer<{ dispatch: unknown; }, {}>' i... Remove this comment to see the full error message
    middleware = applyMiddleware(...middleware);
    
    /* istanbul ignore next */
    if (process.env.NODE_ENV !== 'production') {
        // @ts-expect-error ts-migrate(2740) FIXME: Type 'StoreEnhancer<unknown, {}>' is missing the f... Remove this comment to see the full error message
        middleware = composeWithDevTools(middleware);
    }
    
    return createStore(
        rootReducer,
        // @ts-expect-error ts-migrate(2769) FIXME: Type 'any[]' has no properties in common with type... Remove this comment to see the full error message
        middleware,
    );
}
